module.exports = __webpack_public_path__ + "assets/images/t4b-logo.svg";